import {
    API_TIME_FORMAT,
    API_DATE_FORMAT, LOAD_TYPE
} from "../constants";
import { getUTC, toCustomDate } from './moment-ex';
import { parseJSON } from "./common";
import CryptoJS from "crypto-js";

const mainKeyName = "UlkX_BfQ5weNK_RfIybBm67";
const organizationKeyName = "vIx0a6A1rorCEs3BkpVIsIGF4";
const farmKeyName = "MTUyMzQzMdsdb11enwjo5weos";
const tokenKeyName = "eyJ1aWQiOjQ0MDAy";
const settingsKeyName = "hdCI6MTUyMzQzMzc4M3";
const searchParamsKeyName = "f1dbbb4b0b11e991c242010a76";
const permissionKeyName = "hajsdsdnwjoosnskks";
const appStateKeyName = "5fb9994ca8bf4f0a9918";
const logoutMessageKeyName = "NxJlbTS4-1Xnv47kMzvy";
const loginStatusKeyName = "0vRzgw2tAutrZcAi2sJk";
const chatIdKeyName = "e663f89d4b08af491";
const loadQueueInputKey = "Jh7pQr2Kt9sF5wZ8";
const loadQueueOptionsKey = "b4b201b1c2476f1d0b11e990ab";
const plantingQueueOptionsKey = "bsr3jdsf32rtkie56opb";
const plantingQueueInputKey = "ad2r0ekelda21a142bne";

export const loadHistoryFilterName = "b4b201b1c24721a142bne";
export const tareHistoryFilterName = "fh5878hg58721bsr3jds";
export const searchKeyName = "fh5878hg58732dukfh";
export const selectedRegionIdKey = "4f0a9918ad2r0ekel";
export const geoRegionObjKey = "9918ad2r02r0ekel";
export const geoRegionListKey = "b7e8f1021a9g2lqm";
export const addSeedFormKey = '7b8c1234e7d5q9wlx';
export const addLogisticsFormKey = 'a3d2f567b9j1z8vkc';
export const scaleMachineKey = 'e4f7c893m2n6x1qz';

export const isAuthenticated = () =>
(localStorage.getItem(mainKeyName) !== null
    && localStorage.getItem(permissionKeyName) !== null
    && localStorage.getItem(farmKeyName) !== null);

export const setUserInfo = (userInfo) => {
    localStorage.setItem(mainKeyName, JSON.stringify(userInfo));
}

export const getUserInfo = () => {
    const userInfo = localStorage.getItem(mainKeyName);
    return (userInfo && userInfo !== null ? parseJSON(userInfo) : null);
}

export const getGUID = () => {
    const userInfo = localStorage.getItem(mainKeyName);
    return (userInfo && userInfo !== null ? JSON.parse(userInfo).cid : null);
}

export const getUserId = () => {
    const userInfo = localStorage.getItem(mainKeyName);
    return (userInfo && userInfo !== null ? JSON.parse(userInfo).userId : null);
}

export const getLoginId = () => {
    const userInfo = localStorage.getItem(mainKeyName);
    return (userInfo && userInfo !== null ? JSON.parse(userInfo).loginId : null);
}

export const getAccessKey = () => {
    const userInfo = localStorage.getItem(mainKeyName);
    return (userInfo && userInfo !== null ? JSON.parse(userInfo).accessKey : null);
}

export const setOrganizationInfo = (organizationInfo) => {
    localStorage.setItem(organizationKeyName, JSON.stringify(organizationInfo));
}

export const getOrganizationInfo = () => {
    const organizationInfo = localStorage.getItem(organizationKeyName);
    return (organizationInfo && organizationInfo !== null ? parseJSON(organizationInfo) : null);
}

export const getTimezoneIdentifier = () => {
    const farmInfo = localStorage.getItem(farmKeyName);
    return (farmInfo && farmInfo !== null ? JSON.parse(farmInfo).timezone_identifier : null);
}

export const getTimezone = () => {
    const farmInfo = localStorage.getItem(farmKeyName);
    return (farmInfo && farmInfo !== null ? JSON.parse(farmInfo).timezone : null);
}

export const getLoadType = () => {
    let farmInfo = localStorage.getItem(farmKeyName);
    farmInfo = farmInfo ? parseJSON(farmInfo) : null;
    return (farmInfo && farmInfo.load_type ? farmInfo.load_type : LOAD_TYPE.MANUAL);
}

export const setToken = (token) => {
    localStorage.setItem(tokenKeyName, token);
}

export const getToken = () => {
    const token = localStorage.getItem(tokenKeyName);
    return (token && token !== null ? token : null);
}

export const getFarmInfo = () => {
    const farmInfo = localStorage.getItem(farmKeyName);
    return (farmInfo && farmInfo !== null ? parseJSON(farmInfo) : null);
}

export const setFarmInfo = data => {
    if (!data) return;
    let farmInfo = localStorage.getItem(farmKeyName);
    farmInfo = farmInfo ? parseJSON(farmInfo) : null;
    farmInfo = farmInfo ? farmInfo : {};
    localStorage.setItem(farmKeyName, JSON.stringify({
        ...farmInfo, ...data,
        load_type: (data.load_type || LOAD_TYPE.MANUAL)
    }));
}

export const setChatAppId = (chatId) => localStorage.setItem(chatIdKeyName, JSON.stringify(chatId.appId));

export const getChatAppId = () => {
    const encryptedId = localStorage.getItem(chatIdKeyName);
    if (!encryptedId) return;

    const bytes = CryptoJS.AES.decrypt(parseJSON(encryptedId), '73e8776c-bf97');
    const decryptedId = bytes.toString(CryptoJS.enc.Utf8);

    return (decryptedId && decryptedId !== null ? decryptedId.toString() : null);
}

export const clearChatId = () => localStorage.removeItem(chatIdKeyName);

export const setPermission = (permission) => {
    localStorage.setItem(permissionKeyName, JSON.stringify(permission));
}

export const getPermission = () => {
    const permission = localStorage.getItem(permissionKeyName);
    return (permission && permission !== null ? parseJSON(permission) : null);
}

export const setSettings = (data) => {
    if (data === -1) localStorage.removeItem(settingsKeyName);
    else if (data) localStorage.setItem(settingsKeyName, JSON.stringify(data));
}

export const getSettings = () => {
    const setttings = localStorage.getItem(settingsKeyName);
    return (setttings && setttings !== null ? parseJSON(setttings) : null);
}

export const setSearchRangeParams = (item, timezone) => {
    let searchInfo = localStorage.getItem(searchParamsKeyName);
    if (searchInfo && searchInfo !== null) searchInfo = parseJSON(searchInfo);
    else searchInfo = getDefaultSearchParams(timezone);
    localStorage.setItem(searchParamsKeyName, JSON.stringify({ ...searchInfo, ...item }));
}

export const getDefaultSearchParams = (timezone) => ({
    range: "today",
    customRange: "today",
    custom: getDefaultCustomDate(timezone),
    absolute: getDefaultCustomDate(timezone)
});

export const getRangeType = (timezone) => {
    let searchInfo = localStorage.getItem(searchParamsKeyName);
    if (searchInfo && searchInfo !== null) searchInfo = parseJSON(searchInfo);
    else searchInfo = getDefaultSearchParams(timezone);
    return searchInfo.range;
}

export const getCustomRangeType = (timezone) => {
    let searchInfo = localStorage.getItem(searchParamsKeyName);
    if (searchInfo && searchInfo !== null) searchInfo = parseJSON(searchInfo);
    else searchInfo = getDefaultSearchParams(timezone);
    return searchInfo.customRange;
}

export const getCustomDate = (timezone) => {
    let searchInfo = localStorage.getItem(searchParamsKeyName);
    let customInfo = null;
    if (searchInfo && searchInfo !== null) {
        searchInfo = parseJSON(searchInfo);
        if (searchInfo.custom && searchInfo.custom !== null) customInfo = searchInfo.custom;
    }
    if (!customInfo) customInfo = getDefaultCustomDate(timezone);
    return customInfo;
}

export const getAbsoluteDate = (timezone) => {
    let searchInfo = localStorage.getItem(searchParamsKeyName);
    let absoluteInfo = null;
    if (searchInfo && searchInfo !== null) {
        searchInfo = parseJSON(searchInfo);
        if (searchInfo.absolute && searchInfo.absolute !== null) absoluteInfo = searchInfo.absolute;
    }
    if (!absoluteInfo) absoluteInfo = getDefaultCustomDate(timezone);
    return absoluteInfo;
}

export const getDefaultCustomDate = (timezone) => {
    const startDate = getUTC().tz(timezone).startOf("days").format(`${API_DATE_FORMAT} ${API_TIME_FORMAT}`);
    const endDate = getUTC().tz(timezone).endOf("days").format(`${API_DATE_FORMAT} ${API_TIME_FORMAT}`);
    const dateObj = toCustomDate(startDate, endDate);
    return dateObj;
}

export const getAppState = () => {
    const item = localStorage.getItem(appStateKeyName);
    const appData = item ? parseJSON(item) : null;
    return appData ? appData : {};
}

export const setAppState = data => {
    if (!data) return;
    let appData = localStorage.getItem(appStateKeyName);
    appData = appData ? parseJSON(appData) : null;
    appData = appData ? appData : {};
    localStorage.setItem(appStateKeyName, JSON.stringify({ ...appData, ...data }));
}

export const getLogoutMessage = () => {
    const message = localStorage.getItem(logoutMessageKeyName);
    return message;
}

export const setLogoutMessage = (message) => {
    localStorage.setItem(logoutMessageKeyName, message);
}

export const getLoginStatus = () => {
    const message = localStorage.getItem(loginStatusKeyName);
    return message;
}

export const setLoginStatus = (message) => {
    localStorage.setItem(loginStatusKeyName, message);
}

export const setItem = (name, data) => {
    if (!data) return;
    const item = getItem(name);
    if (item) localStorage.setItem(name, JSON.stringify({ ...item, ...data }));
    else localStorage.setItem(name, JSON.stringify(data));
}

export const getItem = name => {
    const item = localStorage.getItem(name);
    return (item && item !== null ? parseJSON(item) : null);
}

export const removeItem = name => localStorage.removeItem(name);

export const clearSession = () => localStorage.clear();

export const setSearchQueryData = (data) => {
    localStorage.setItem(searchKeyName, JSON.stringify(data));
    return true;
}

export const getSearchQueryData = (searchId) => {
    if (!searchId) return null;
    const searchQuery = localStorage.getItem(searchKeyName) ? JSON.parse(localStorage.getItem(searchKeyName)) : null;
    if (!searchQuery) return null;
    return searchQuery['search_id'] === searchId ? searchQuery['data'] : null;
}

export const setLoadQueueSessionInputs = (datas) => {
    localStorage.setItem(loadQueueInputKey, JSON.stringify(datas));
}

export const getLoadQueueSessionInputs = () => {
    const res = localStorage.getItem(loadQueueInputKey);
    return (res && !["undefined", "null"].includes(res)) ? JSON.parse(res) : null;
}

export const removeLoadQueueSessionInputs = () => {
    localStorage.removeItem(loadQueueInputKey);
    localStorage.removeItem(loadQueueOptionsKey);
    localStorage.removeItem(addSeedFormKey);
    localStorage.removeItem(addLogisticsFormKey);
}

export const setLoadQueOptionSession = (datas) => {
    localStorage.setItem(loadQueueOptionsKey, JSON.stringify(datas));
}

export const getLoadQueOptionSession = () => {
    const res = localStorage.getItem(loadQueueOptionsKey);
    return (res && !["undefined", "null"].includes(res)) ? JSON.parse(res) : null;
}

export const setPlantingQueueSessionInputs = (datas) => {
    localStorage.setItem(plantingQueueInputKey, JSON.stringify(datas));
}

export const getPlantingQueueSessionInputs = () => {
    const res = localStorage.getItem(plantingQueueInputKey);
    return (res && !["undefined", "null"].includes(res)) ? JSON.parse(res) : null;
}

export const setPlantingQueOptionSession = (datas) => {
    localStorage.setItem(plantingQueueOptionsKey, JSON.stringify(datas));
}

export const getPlantingQueOptionSession = () => {
    const res = localStorage.getItem(plantingQueueOptionsKey);
    return (res && !["undefined", "null"].includes(res)) ? JSON.parse(res) : null;
}
export const isAdmin = () => {
    const roleId = getUserInfo().role_id;
    return roleId === 1 || roleId === 2;
}

export const setLHFilter = (message) => {
    localStorage.setItem(loadHistoryFilterName, message ? JSON.stringify(message) : null);
}

export const getLHFilter = () => {
    const info = localStorage.getItem(loadHistoryFilterName);
    return (info && info !== null ? parseJSON(info) : null);
}

export const setTHFilter = (message) => {
    localStorage.setItem(tareHistoryFilterName, message ? JSON.stringify(message) : null);
}

export const getTHFilter = () => {
    const info = localStorage.getItem(tareHistoryFilterName);
    return (info && info !== null ? parseJSON(info) : null);
}

export const setSelectedRegionId = (message) => {
    localStorage.setItem(selectedRegionIdKey, message ? JSON.stringify(message) : null);
}

export const getSelectedRegionId = () => {
    const info = localStorage.getItem(selectedRegionIdKey);
    return (info && info !== null ? parseJSON(info) : null);
}

export const setGeoRegionObj = (message) => {
    localStorage.setItem(geoRegionObjKey, message ? JSON.stringify(message) : null);
}

export const getGeoRegionObj = () => {
    const info = localStorage.getItem(geoRegionObjKey);
    return (info && info !== null ? parseJSON(info) : null);
}

export const setGeoRegionList = (message) => {
    localStorage.setItem(geoRegionListKey, message ? JSON.stringify(message) : null);
}

export const getGeoRegionList = () => {
    const info = localStorage.getItem(geoRegionListKey);
    return (info && info !== null ? parseJSON(info) : []);
}

export const setSeedFormDetails = (message = null) => {
    localStorage.setItem(addSeedFormKey, message ? JSON.stringify(message) : null);
}

export const getSeedFormDetails = () => {
    const info = localStorage.getItem(addSeedFormKey);
    return (info && info !== null ? parseJSON(info) : {});
}

export const setLogisticsFormDetails = (message = null) => {
    localStorage.setItem(addLogisticsFormKey, message ? JSON.stringify(message) : null);
}

export const getLogisticsFormDetails = () => {
    const info = localStorage.getItem(addLogisticsFormKey);
    return (info && info !== null ? parseJSON(info) : {});
}

export const setScaleMachineDetails = (message = null) => {
    localStorage.setItem(scaleMachineKey, message ? JSON.stringify(message) : null);
}

export const getScaleMachineDetails = () => {
    const info = localStorage.getItem(scaleMachineKey);
    return (info && info !== null ? parseJSON(info) : {});
}